/**
 * LavorazioneApp - App Modulare Lavorazione
 *
 * Entry point per l'app Lavorazione che gestisce:
 * - Turbine
 * - FAP
 * - Iniettori
 * - QR Scan
 * - Photo Sessions
 *
 * Usa core components: Chat, PhotoCapture, WebSocket
 * Architettura: ARCHITETTURA_DEFINITIVA_CORE_APPS.md
 */

import { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, LayoutDashboard } from 'lucide-react';
import { ChatModal } from '../../core/components/Chat';
import { useChatWebSocket } from '../../core/hooks';

// Pages
import HomePage from './pages/HomePage';
import EntityListPage from './pages/EntityListPage';
import EntityDetailPage from './pages/EntityDetailPage';

// @ts-ignore - Interface per uso futuro deep link
interface _LavorazioneAppProps {
  pendingRequest?: any;  // Richiesta da deep link (futuro)
}

function LavorazioneApp() {
  const navigate = useNavigate();
  const [showChat, setShowChat] = useState(false);
  const [sessionId] = useState('lavorazione-session-' + Date.now());

  // Chat WebSocket (usa core)
  const { wsConnected } = useChatWebSocket({
    sessionId,
    clientType: 'desktop',
    enabled: showChat
  });

  return (
    <div className="min-h-screen bg-gray-900">
      {/* App Header */}
      <header className="bg-gray-800 shadow-xl sticky top-0 z-10 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/menu-hub')}
              className="p-2 hover:bg-gray-700 rounded-lg transition-colors text-gray-300"
              title="Torna al Menu"
            >
              <ArrowLeft className="w-6 h-6" />
            </button>

            <div className="text-4xl">🔧</div>

            <div>
              <h1 className="text-xl font-bold text-gray-100">Lavorazione</h1>
              <p className="text-xs text-gray-400">Turbine • FAP • Iniettori</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setShowChat(true)}
              className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors inline-flex items-center gap-2"
            >
              💬 Chat
              {wsConnected && (
                <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              )}
            </button>

            <button
              onClick={() => window.location.href = '/dashboard'}
              className="p-2 hover:bg-gray-700 rounded-lg transition-colors text-gray-300"
              title="Dashboard Principale"
            >
              <LayoutDashboard className="w-6 h-6" />
            </button>

            <button
              onClick={() => navigate('/menu-hub')}
              className="p-2 hover:bg-gray-700 rounded-lg transition-colors text-gray-300"
              title="Menu Apps"
            >
              <Home className="w-6 h-6" />
            </button>
          </div>
        </div>
      </header>

      {/* App Routes */}
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Routes>
          {/* Home: Selezione tipo entità */}
          <Route path="/" element={<HomePage />} />

          {/* Lista entità (turbine/FAP/iniettori) */}
          <Route path="/list" element={<EntityListPage />} />

          {/* Dettaglio entità */}
          <Route path="/entity/:entityId" element={<EntityDetailPage />} />

          {/* TODO: Altre route */}
          {/* <Route path="/scan" element={<QRScannerPage />} /> */}
          {/* <Route path="/photo-capture" element={<PhotoCapturePage />} /> */}
        </Routes>
      </main>

      {/* Chat Modal (CORE component) */}
      {showChat && (
        <ChatModal
          isOpen={showChat}
          onClose={() => setShowChat(false)}
          sessionId={sessionId}
          autoOpenChat={false}
          setAutoOpenChat={() => {}}
        />
      )}
    </div>
  );
}

export default LavorazioneApp;
